import StandardModal from "./StandardModal";
import ModalSize from "./ModalSize";
import FirebaseService from "../../services/firebase/FirebaseService";
import { useAssignmentModalState } from "./modalHooks";
import { RootState } from "../../state/configureStore";
import { useSelector } from "react-redux";

interface DeleteAssignmentModalProps {
  open: boolean;
  cancelClose: () => void;
}

const DeleteAssignmentModal = ({ ...props }: DeleteAssignmentModalProps) => {
  const { loadingProps, enqueueSnackbar, assignmentId, assignment, title, history } = useAssignmentModalState();
  const userId = useSelector((state: RootState) => state.currentUserState.currentUser?.uid) || "";
  const deleteAssignment = async () => {
    if (!assignment || userId.length === 0) {
      enqueueSnackbar("Could not delete this assignment", "error");
      return;
    }
    try {
      await FirebaseService.updateAssignmentIsActive(userId, assignmentId, false);
      enqueueSnackbar(`Assignment ${title}`, "success");
      props.cancelClose();
      history.push("/Assignments/all");
    } catch (e) {
      enqueueSnackbar("Could not delete this assignment", "error");
    }
  };
  return (
    <StandardModal
      title="Delete Assignment?"
      size={ModalSize.medium}
      submitButtonText="Delete"
      onSubmit={deleteAssignment}
      {...loadingProps}
      {...props}
    >
      Do you want to delete {title}?
    </StandardModal>
  );
};

export default DeleteAssignmentModal;
